// extracted by mini-css-extract-plugin
export var measureBox = "_bi-0";